import { StateUtils } from '@spartacus/core';
import { LoyaltyQrResponse } from '@user/const';
import { LOYALTY_QR } from '../user-state';

export const LOAD_LOYALTY_QR = '[LoyaltyQr] Load Loyalty QR';
export const LOAD_LOYALTY_QR_SUCCESS = '[LoyaltyQr] Load Loyalty QR Success';
export const LOAD_LOYALTY_QR_FAIL = '[LoyaltyQr] Load Loyalty QR Fail';

export class LoadLoyaltyQr extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_LOYALTY_QR;

  constructor() {
    super(LOYALTY_QR);
  }
}

export class LoadLoyaltyQrFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_LOYALTY_QR_FAIL;

  constructor() {
    super(LOYALTY_QR);
  }
}

export class LoadLoyaltyQrSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_LOYALTY_QR_SUCCESS;

  constructor(public payload: LoyaltyQrResponse) {
    super(LOYALTY_QR);
  }
}

export type LoyaltyQrActions = LoadLoyaltyQr | LoadLoyaltyQrFail | LoadLoyaltyQrSuccess;
